// QA only. Keeps fulfillment gifts as explicit $0 Shopify line items.
export const GIFTS = { blade: 58788750950560, mallet: 58788775526560, tag: 58788750885024 };
const MEMBERSHIP = 57232895115424;

const PUTTER_PRODUCTS = new Map([
  [6658769748128, GIFTS.blade],   // Longtail
  [9516128993440, GIFTS.blade],   // Heron
  [15732971536544, GIFTS.blade],  // Cahow
  [15689854648480, GIFTS.mallet], // Merlin
]);

const PUTTER_VARIANTS = new Map([
  ...[57702445121696,57702445154464,57702445187232,58120041889952,
    58087239123104,58087239155872,58087239188640,58087239221408].map(id => [id, GIFTS.blade]),
  ...[57699644866720,57699644932256].map(id => [id, GIFTS.mallet]),
]);
const giftIds = new Set(Object.values(GIFTS));
const nativeFetch = globalThis.fetch.bind(globalThis);

function giftForItem(item) {
  return PUTTER_PRODUCTS.get(Number(item.product_id)) || PUTTER_VARIANTS.get(Number(item.variant_id));
}

export function initialMembershipPurchaseItems(mainVariantId, quantity, membership) {
  const mainId = Number(mainVariantId);
  const headcoverId = PUTTER_VARIANTS.get(mainId);
  const items = [
    { variantId: String(membership.variantId), quantity: 1, ...(membership.sellingPlanId ? { sellingPlanId: membership.sellingPlanId } : {}) },
    { variantId: String(mainVariantId), quantity, isMainProduct: true },
  ];
  return items;
}

export function parentIdentity(item) {
  const properties = Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b));
  const plan = item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || null;
  return JSON.stringify([Number(item.variant_id || item.id), properties, plan]);
}

export function nextGiftAction(cart) {
  const wanted = new Map();
  const parentGroups = new Map();
  let membership = null;

  for (const item of cart.items || []) {
    if (giftIds.has(Number(item.variant_id)) || item.quantity <= 0) continue;
    if (Number(item.variant_id) === MEMBERSHIP) membership = item;
    const id = giftForItem(item);
    if (!id) continue;
    const identity = parentIdentity(item);
    const group = wanted.get(identity) || { id, quantity: 0, parents: new Set(), parentLineKey: item.key, identity };
    group.quantity += item.quantity;
    group.parents.add(item.key);
    wanted.set(identity, group);
    parentGroups.set(item.key, identity);
  }

  if (wanted.size && membership) {
    const identity = 'membership-tag';
    wanted.set(identity, { id: GIFTS.tag, quantity: 1, parents: new Set([membership.key]), parentLineKey: membership.key, identity });
    parentGroups.set(membership.key, identity);
  }

  const found = new Set();
  for (const [index, item] of (cart.items || []).entries()) {
    const id = Number(item.variant_id);
    if (!giftIds.has(id)) continue;
    const parentKey = item.parent_relationship?.parent?.key || item.parent_relationship?.parent_key;
    const identity = parentGroups.get(parentKey) || item.properties?._paradise_parent;
    const expected = wanted.get(identity);
    if (!parentKey || !expected || expected.id !== id || found.has(identity) || item.selling_plan_allocation) {
      return { type: 'change', line: index + 1, quantity: 0 };
    }
    found.add(identity);
    if (item.quantity !== expected.quantity) {
      return { type: 'change', line: index + 1, quantity: expected.quantity };
    }
  }

  for (const [identity, gift] of wanted) {
    if (found.has(identity)) continue;
    return { type: 'add', items: [{
      id: gift.id,
      quantity: gift.quantity,
      parent_line_key: gift.parentLineKey,
      properties: {
        _paradise_included: '1',
        _paradise_parent: identity,
        ...(gift.id === GIFTS.tag ? { _paradise_membership_gift: '1' } : {}),
      },
    }] };
  }
  return null;
}

const configuration = () => {
  const element = globalThis.document?.getElementById('paradise-included-gifts-config');
  return element ? JSON.parse(element.textContent) : { enabled: false, existingMember: false };
};
const root = () => globalThis.Shopify?.routes?.root || '/';

function installCartDrawerPresentation() {
  if (document.getElementById('paradise-cart-drawer-ui')) return;
  const style = document.createElement('style');
  style.id = 'paradise-cart-drawer-ui';
  style.textContent = `
    :is(.cart-drawer, #cart-form) .cart-items__table,
    :is(.cart-drawer, #cart-form) .cart-items__table * { text-align:left; --text-align:left; }
    :is(.cart-drawer, #cart-form) .cart-items__table { font-family:var(--font-body--family, inherit); }
    :is(.cart-drawer, #cart-form) tbody { display:flex; flex-direction:column; gap:.15rem; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row {
      width:100%; grid-template-columns:5rem minmax(0,1fr) max-content;
      grid-template-rows:auto auto auto; grid-template-areas:'media details price' 'media quantity quantity' 'media error error';
      column-gap:1rem; row-gap:.75rem; align-items:start; padding:1rem 0 1.2rem; margin:0;
    }
    :is(.cart-drawer, #cart-form) tbody .cart-items__media { grid-area:media; width:5rem; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__media-container { width:5rem; height:5rem; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__details { grid-area:details; display:block!important; min-width:0; font-family:var(--font-body--family, inherit); font-style:normal; }
    :is(.cart-drawer, #cart-form) .cart-items__product-info p { margin:0; }
    :is(.cart-drawer, #cart-form) .cart-items__title { display:block; font-family:var(--font-heading--family, var(--font-body--family, inherit)); font-style:var(--font-heading--style, normal); font-size:1.25rem; line-height:1.15; font-weight:var(--font-heading--weight, 400); overflow-wrap:normal; }
    :is(.cart-drawer, #cart-form) .cart-items__variants-wrapper { display:flex; flex-wrap:wrap; align-items:center; gap:.25rem .75rem; margin-block-start:.45rem; color:rgb(var(--color-foreground-rgb)/.62); font-size:.92rem; line-height:1.35; }
    :is(.cart-drawer, #cart-form) .cart-items__variants-wrapper>*, :is(.cart-drawer, #cart-form) .cart-items__variants-wrapper li, :is(.cart-drawer, #cart-form) .cart-items__variants, :is(.cart-drawer, #cart-form) .cart-items__properties, :is(.cart-drawer, #cart-form) .cart-items__variant, :is(.cart-drawer, #cart-form) .cart-items__property { display:inline-flex; margin:0; padding:0; gap:.2rem; white-space:nowrap; }
    :is(.cart-drawer, #cart-form) .cart-items__unit-price-wrapper { display:none!important; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__price { grid-area:price; align-self:start; min-width:max-content; max-width:none; white-space:nowrap; font-family:var(--font-body--family, inherit); font-size:1rem; line-height:1.2; font-variant-numeric:tabular-nums; display:flex!important; align-items:baseline; gap:.45rem; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__quantity { grid-area:quantity; width:auto; min-width:0; margin:0; justify-self:start; }
    :is(.cart-drawer, #cart-form) .paradise-compare-at-price { color:rgb(var(--color-foreground-rgb)/.48); font-size:.88em; text-decoration:line-through; }
    :is(.cart-drawer, #cart-form) .cart-items__quantity-controls, :is(.cart-drawer, #cart-form) .quantity-selector-wrapper, :is(.cart-drawer, #cart-form) .quantity-selector { display:flex; flex-wrap:nowrap; align-items:center; white-space:nowrap; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:has(a[href^="/products/members-only?"]) { position:relative; min-height:6.2rem; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:has(a[href^="/products/members-only?"]) .quantity-selector-wrapper { display:none!important; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:has(a[href^="/products/members-only?"]) .cart-items__quantity { position:absolute; right:0; bottom:.55rem; width:auto; height:auto!important; min-height:0!important; margin:0; align-items:flex-end; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:has(a[href^="/products/members-only?"]) .cart-items__quantity button[aria-label^="Remove"] { position:static!important; transform:translateY(1.1rem); }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:not(.paradise-included-gift-line) { position:relative; padding-block-end:0; }
    :is(.cart-drawer, #cart-form) tbody .cart-items__table-row:not(.paradise-included-gift-line) .cart-items__quantity button[aria-label^="Remove"] { position:absolute; right:0; bottom:.55rem; }
    :is(.cart-drawer, #cart-form) tbody .paradise-included-gift-line { position:relative; width:calc(100% - 1.5rem)!important; margin:.1rem 0 2.1rem 1.5rem; padding:.7rem 1rem!important; border-radius:var(--style-border-radius-lg, .5rem); background:rgb(var(--color-foreground-rgb)/.045); grid-template-columns:4rem minmax(0,1fr) max-content; grid-template-rows:auto; grid-template-areas:'media details price'; align-items:center; box-sizing:border-box; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line::before { content:''; position:absolute; left:-1rem; top:-1.1rem; width:1rem; height:50%; border-left:1px solid rgb(var(--color-foreground-rgb)/.22); border-bottom:1px solid rgb(var(--color-foreground-rgb)/.22); }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__media { width:4rem!important; justify-self:start!important; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__media-container { width:4rem!important; height:4rem!important; margin:0!important; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__title { font-size:1.08rem; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__quantity { display:none!important; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__price { flex-direction:column; align-items:flex-end; gap:0; }
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .paradise-hidden-gift-price,
    :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__details .cart-items__price { display:none!important; }
    :is(.cart-drawer, #cart-form) .paradise-included-copy { margin:.35rem 0 0; color:rgb(var(--color-foreground-rgb)/.58); font-size:.86rem; line-height:1.3; }
    :is(.cart-drawer, #cart-form) .paradise-included-badge { display:inline-flex; align-items:center; justify-content:center; padding:.38rem .75rem; border-radius:999px; background:rgb(var(--color-foreground-rgb)/.08); color:rgb(var(--color-foreground-rgb)/.68); font-size:.7rem; font-weight:600; letter-spacing:.12em; line-height:1; text-transform:uppercase; }
    @media (min-width:750px) { :is(.cart-drawer, #cart-form) :is(.cart-drawer, #cart-form)__dialog { width:min(36rem, 100vw) !important; max-width:36rem !important; } }
    @media (max-width:420px) {
      :is(.cart-drawer, #cart-form) tbody .cart-items__table-row { grid-template-columns:4rem minmax(0,1fr) max-content; column-gap:.75rem; }
      :is(.cart-drawer, #cart-form) tbody .cart-items__media, :is(.cart-drawer, #cart-form) tbody .cart-items__media-container { width:4rem; height:4rem; }
      :is(.cart-drawer, #cart-form) .cart-items__title { font-size:1.08rem; }
      :is(.cart-drawer, #cart-form) tbody .cart-items__price { font-size:.92rem; }
      :is(.cart-drawer, #cart-form) .paradise-included-gift-line { width:calc(100% - 1rem)!important; margin-left:1rem; padding:.8rem!important; grid-template-columns:3.5rem minmax(0,1fr); grid-template-areas:'media details' 'media price'; }
      :is(.cart-drawer, #cart-form) .paradise-included-gift-line::before { left:-.75rem; width:.55rem; }
      :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__media, :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__media-container { width:3.5rem; height:3.5rem; }
      :is(.cart-drawer, #cart-form) .paradise-included-gift-line .cart-items__price { align-items:flex-start; margin-top:.45rem; flex-direction:row; }
    }
    `;
  document.head.append(style);
}
installCartDrawerPresentation();

// Included gifts are controlled by their parent item. Hide their quantity selector
// and delete control anywhere Horizon renders the cart, while preserving the real line item.
let includedGiftKeys = new Set();
let includedGiftOrder = new Map();
let includedComparePrices = new Map();
function applyIncludedGiftPresentation() {
  for (const row of document.querySelectorAll('[data-key]')) {
    const key = row.getAttribute('data-key');
    if (!key) continue;
    const isGift = row.dataset.includedGift === 'true' || includedGiftKeys.has(key);

    row.classList.toggle('paradise-included-gift-line', isGift);
    if (isGift) {
      const details = row.querySelector('.cart-items__details');
      const prices = Array.from(row.querySelectorAll('.cart-items__price'));
      const price = prices.at(-1);
      const isBagTag = Boolean(row.querySelector('a[href*="members-only-bag-tag"]'));
      if (details && !details.querySelector('.paradise-included-copy')) {
        const copy = document.createElement('p');
        copy.className = 'paradise-included-copy';
        copy.textContent = isBagTag ? 'Included with your new membership + eligible club order' : 'Included with your putter';
        details.querySelector('.cart-items__title')?.after(copy);
      }
      if (price && !price.querySelector('.paradise-included-badge')) {
        const badge = document.createElement('span');
        badge.className = 'paradise-included-badge';
        badge.textContent = 'Included';
        price.append(badge);
        for (const child of Array.from(price.children)) {
          if (!child.classList.contains('paradise-included-badge')) child.classList.add('paradise-hidden-gift-price');
        }
        for (const node of Array.from(price.childNodes)) {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
        }
      }
    }
    const order = includedGiftOrder.get(key);
    if (order !== undefined) row.style.order = String(order);
    const linePrice = row.querySelector('.cart-items__price');
    const comparePrice = includedComparePrices.get(key);
    if (comparePrice && linePrice && !linePrice.querySelector('.paradise-compare-at-price')) {
      const compare = document.createElement('s');
      compare.className = 'paradise-compare-at-price';
      compare.textContent = comparePrice;
      linePrice.prepend(compare);
    }
    if (row.querySelector('a[href^="/products/members-only?"]')) {
      const quantityCell = row.querySelector('.cart-items__quantity');
      if (quantityCell instanceof HTMLElement) {
        quantityCell.style.setProperty('position', 'absolute', 'important');
        quantityCell.style.setProperty('right', '0', 'important');
        quantityCell.style.setProperty('bottom', '0.55rem', 'important');
        quantityCell.style.setProperty('justify-content', 'flex-end', 'important');
      }
    }
    if (isGift) {
      const quantityCell = row.querySelector('.cart-items__quantity');
      if (quantityCell instanceof HTMLElement) quantityCell.style.setProperty('display', 'none', 'important');
    }
  }
}
function rememberIncludedGiftKeys(cart) {
  const items = cart?.items || [];
  includedGiftKeys = new Set(items.filter(item => giftIds.has(Number(item.variant_id))).map(item => item.key));
  includedComparePrices = new Map(
    items
      .filter(item => Number(item.original_line_price) > Number(item.final_line_price))
      .map(item => [item.key, new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(item.original_line_price) / 100)]),
  );

  const children = new Map();
  for (const item of items) {
    const parentKey = item.parent_relationship?.parent?.key || item.parent_relationship?.parent_key;
    if (!parentKey) continue;
    if (!children.has(parentKey)) children.set(parentKey, []);
    children.get(parentKey).push(item);
  }
  const ordered = [];
  const seen = new Set();
  const appendGroup = item => {
    if (!item || seen.has(item.key)) return;
    ordered.push(item); seen.add(item.key);
    for (const child of children.get(item.key) || []) {
      ordered.push(child); seen.add(child.key);
    }
  };
  for (const item of items) if (giftForItem(item)) appendGroup(item);
  for (const item of items) {
    if (!giftIds.has(Number(item.variant_id)) && Number(item.variant_id) !== MEMBERSHIP) appendGroup(item);
  }
  appendGroup(items.find(item => Number(item.variant_id) === MEMBERSHIP));
  for (const item of items) appendGroup(item);
  includedGiftOrder = new Map(ordered.map((item, index) => [item.key, index]));
  applyIncludedGiftPresentation();
}

if (globalThis.MutationObserver && document.documentElement) {
  const observer = new MutationObserver(() => applyIncludedGiftPresentation());
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

let cartQueue = Promise.resolve();
function queueCartWork(work) {
  const pending = cartQueue.then(work);
  cartQueue = pending.catch(() => {});
  return pending;
}

export function reconcileIncludedGifts(options = {}) {
  return queueCartWork(() => settleIncludedGifts(options));
}

async function settleIncludedGifts({ notify = true } = {}) {
  const config = configuration();
  if (!config.enabled) return null;
  let changed = false;
  try {
    for (let attempts = 0; attempts < 30; attempts++) {
      const cartResponse = await nativeFetch(`${root()}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart unavailable');
      const cart = await cartResponse.json();
      const action = nextGiftAction(cart, config);

      if (!action) {
        rememberIncludedGiftKeys(cart);
        if (changed && notify) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'paradise-included-gifts', data: { source: 'included-gifts', sections: {}, itemCount: cart.item_count } },
          }));
        }
        return cart;
      }

      const { type, ...payload } = action;
      const response = await nativeFetch(`${root()}cart/${type}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || 'Included item unavailable');
      changed = true;
    }
    throw new Error('Cart did not settle');
  } catch (error) {
    console.error('[Paradise included gifts]', error);
    return null;
  }
}

function isCartAdd(url) {
  try {
    return new URL(String(url), globalThis.location?.origin || 'https://paradisegolf.co').pathname.replace(/\/+$/, '').endsWith('/cart/add.js');
  } catch {
    return false;
  }
}

function isCartMutation(url) {
  try {
    const path = new URL(String(url), globalThis.location?.origin || 'https://paradisegolf.co').pathname.replace(/\/+$/, '');
    return ['/cart/add.js', '/cart/change.js', '/cart/update.js', '/cart/clear.js'].some(endpoint => path.endsWith(endpoint));
  } catch {
    return false;
  }
}

function requestSectionConfig(options = {}) {
  try {
    const body = options.body;
    if (body instanceof FormData) {
      return { sections: body.get('sections'), sectionsUrl: body.get('sections_url') };
    }
    if (body instanceof URLSearchParams) {
      return { sections: body.get('sections'), sectionsUrl: body.get('sections_url') };
    }
    if (typeof body === 'string' && body.trim()) {
      const parsed = JSON.parse(body);
      return { sections: parsed.sections, sectionsUrl: parsed.sections_url };
    }
  } catch {}
  return { sections: null, sectionsUrl: null };
}

async function freshSections(sections, sectionsUrl) {
  if (!sections) return null;
  const url = new URL(String(sectionsUrl || globalThis.location?.pathname || root()), globalThis.location?.origin || 'https://paradisegolf.co');
  url.searchParams.set('sections', String(sections));
  const response = await nativeFetch(url, { cache: 'no-store', headers: { Accept: 'application/json' } });
  if (!response.ok) return null;
  return response.json();
}

function atomicGiftRequestOptions(input, options = {}) {
  if (!configuration().enabled || !isCartAdd(input) || typeof options.body !== 'string') return options;

  try {
    const payload = JSON.parse(options.body);
    if (!Array.isArray(payload.items)) return options;

    const parentItems = payload.items.filter(item => !giftIds.has(Number(item.id)));
    const membership = parentItems.find(item => Number(item.id) === MEMBERSHIP);
    const qualifying = parentItems.filter(item => PUTTER_VARIANTS.has(Number(item.id)) && Number(item.quantity) > 0);
    if (!qualifying.length) return options;

    const giftItems = qualifying.map(parent => ({
      id: PUTTER_VARIANTS.get(Number(parent.id)),
      quantity: Number(parent.quantity) || 1,
      parent_id: Number(parent.id),
      properties: { _paradise_included: '1', _paradise_parent: parentIdentity(parent) },
    }));

    if (membership) {
      giftItems.push({
        id: GIFTS.tag,
        quantity: 1,
        parent_id: MEMBERSHIP,
        properties: { _paradise_included: '1', _paradise_membership_gift: '1', _paradise_parent: 'membership-tag' },
      });

    }

    const orderedParents = [
      ...qualifying,
      ...parentItems.filter(item => !qualifying.includes(item) && item !== membership),
      ...(membership ? [membership] : []),
    ];
    return { ...options, body: JSON.stringify({ ...payload, items: [...orderedParents, ...giftItems] }) };
  } catch {
    return options;
  }
}

// Intercept storefront add requests so fulfillment gifts are settled BEFORE the caller opens
// the cart drawer or redirects to checkout.
globalThis.fetch = function paradiseIncludedGiftFetch(input, options = {}) {
  if (!configuration().enabled || !isCartMutation(input)) return nativeFetch(input, options);
  return queueCartWork(async () => {
    const requestOptions = atomicGiftRequestOptions(input, options);
    const response = await nativeFetch(input, requestOptions);
    if (!response.ok) return response;
    let original;
    try {
      original = await response.clone().json();
      if (original?.status || original?.errors) return response;
    } catch {
      return response;
    }
    const cart = await settleIncludedGifts({ notify: false });
    if (!cart) return response;
    const { sections, sectionsUrl } = requestSectionConfig(requestOptions);
    const sectionsPayload = await freshSections(sections, sectionsUrl);
    const payload = isCartAdd(input) ? original : cart;
    return new Response(JSON.stringify({ ...payload, ...(sectionsPayload ? { sections: sectionsPayload } : {}) }), {
      status: response.status,
      statusText: response.statusText,
      headers: { 'Content-Type': 'application/json' },
    });
  });
};

document.addEventListener('cart:update', (event) => {
  if (event?.detail?.data?.source === 'included-gifts') return;
  setTimeout(() => reconcileIncludedGifts(), 250);
});
document.addEventListener('cart:updated', () => setTimeout(() => reconcileIncludedGifts(), 250));

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => reconcileIncludedGifts());
} else {
  reconcileIncludedGifts();
}

const includedCopyStyle = document.createElement('style');
includedCopyStyle.textContent = '.paradise-included-copy{display:none!important}';
document.head.append(includedCopyStyle);

